module.exports = __webpack_public_path__ + "assets/img/gaokaobj.d81f09f8.png";